<h4>
  {{ "title.dailyTimeExceptions" | translate | async }}
</h4>

<ul [formGroup]="exceptionForm">
  <ng-container formArrayName="exceptions">
    <li *ngFor="let exceptionForm of exceptions.controls; let i = index;" class="exception-list-item">
      <div  [formGroup]="getExceptionControl(i)">
        <div style="display: flex;">
         <mat-checkbox formControlName="isExceptionBalCapacity" [disabled]="getBalancedCapacity(i)">
         {{ "title.balancecapacity" | translate | async }}
      </mat-checkbox>
      <div class="tooltipInside" *ngIf="!getBalancedCapacity(i)">
   <vue-image-tooltip  imageSrc="/assets/icons/icon-exclamation.svg"
              content="{{'tooltip.message.balancecapacity' | translate | async }}"></vue-image-tooltip>
      </div>
        </div>
        <div class="exception-container">
        <vue-select
          label="{{ 'title.time' | translate | async }}"
          formControlName="time"
          [options]="getTimeOptionsForControl(i)"
          [getOptionDisplay]="addUTCToTime.bind(this)"
          [errorMatcher]="suppressErrorState"
        ></vue-select>
        <ng-container formGroupName="capacity">
          <vue-select
            formControlName="type"
            label="{{ 'title.logic' | translate | async }}"
            [options]="this.logicOptions"
            [getOptionDisplay]="getLogicOptionText.bind(this)"
            [errorMatcher]="suppressErrorState"
            
          
          ></vue-select>
          <vue-numeric-input
            formControlName="count"
            label="{{ 'title.capacity' | translate | async }}"
            alignText="left"
            [errorMatcher]="suppressErrorState"
            [maxLength]="5"
          ></vue-numeric-input>
        </ng-container>
        <button
          mat-icon-button
          type="button"
          [attr.aria-label]="'label.aria.removeDailyException' | translate | async"
          class="close-button"
          (click)="removeException(i)"
        >
          <img
            alt=""
            class="close-icon"
            src="../../../../assets/icons/icon-grey-close-x.svg"
          />
        </button>
        </div>
      </div>
    </li>
  </ng-container>
</ul>
<button
  type="button"
  class="add-exception-button"
  (click)="addException()"
  [disabled]="disableAddException()"
>
  <div class="addition"></div>
  {{ "title.addException" | translate | async }}
</button>
